export default "__VITE_ASSET__dfb11494__$_?nuxt_component=async__"